var Category = /* @__PURE__ */ ((Category2) => {
  Category2["APPOINTMENT_HANDLING"] = "APPOINTMENT_HANDLING";
  Category2["BILLING"] = "BILLING";
  Category2["CALL_COLLEAGUE"] = "CALL_COLLEAGUE";
  Category2["CALL_PATIENT"] = "CALL_PATIENT";
  Category2["COST_PLAN"] = "COST_PLAN";
  Category2["DOCUMENTATION"] = "DOCUMENTATION";
  Category2["FOLLOWUP_APPOINTMENT"] = "FOLLOWUP_APPOINTMENT";
  Category2["INFORMATION"] = "INFORMATION";
  Category2["INSURANCE"] = "INSURANCE";
  Category2["MEETING"] = "MEETING";
  Category2["OTHER"] = "OTHER";
  Category2["PAIN_PATIENT"] = "PAIN_PATIENT";
  Category2["PATIENTS_INFORMATION"] = "PATIENTS_INFORMATION";
  Category2["POST_SENDOUT"] = "POST_SENDOUT";
  Category2["PROBLEM_SOLVING"] = "PROBLEM_SOLVING";
  Category2["RECALL"] = "RECALL";
  Category2["REFER_PATIENT"] = "REFER_PATIENT";
  Category2["SHIFT_PLANNING"] = "SHIFT_PLANNING";
  Category2["TREATMENT_INFORMATION"] = "TREATMENT_INFORMATION";
  return Category2;
})(Category || {});
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["TO_DO"] = "TO_DO";
  Status2["IN_PROGRESS"] = "IN_PROGRESS";
  Status2["DONE"] = "DONE";
  return Status2;
})(Status || {});
var EmployeeRole = /* @__PURE__ */ ((EmployeeRole2) => {
  EmployeeRole2["NONE"] = "NONE";
  EmployeeRole2["ASSISTANT"] = "ASSISTANT";
  EmployeeRole2["ACCOUNTANT"] = "ACCOUNTANT";
  EmployeeRole2["HYGIENIST"] = "HYGIENIST";
  EmployeeRole2["DENTIST"] = "DENTIST";
  EmployeeRole2["CLINIC_MANAGER"] = "CLINIC_MANAGER";
  EmployeeRole2["RECEPTIONIST"] = "RECEPTIONIST";
  EmployeeRole2["DENTAL_TECHNICIAN"] = "DENTAL_TECHNICIAN";
  return EmployeeRole2;
})(EmployeeRole || {});
var EmployeeLevel = /* @__PURE__ */ ((EmployeeLevel2) => {
  EmployeeLevel2["CHIEF"] = "CHIEF";
  EmployeeLevel2["SENIOR"] = "SENIOR";
  EmployeeLevel2["JUNIOR"] = "JUNIOR";
  EmployeeLevel2["GRADUATE"] = "GRADUATE";
  return EmployeeLevel2;
})(EmployeeLevel || {});
export {
  Category,
  EmployeeLevel,
  EmployeeRole,
  Status
};
